import unescapedText from 'I18n/utils/unescapedText';
import { getAppInfo } from 'chatspot-core/utils/appUtils';
export const getDashworksSearchToolStartMessage = (connectedApps, appSearchScope) => {
  let appNames = (connectedApps === null || connectedApps === void 0 ? void 0 : connectedApps.map(app => app.appName)) || [];
  if ((appSearchScope === null || appSearchScope === void 0 ? void 0 : appSearchScope.type) === 'SELECTED_APPS') {
    appNames = appSearchScope.includedApps || [];
  }
  const appDisplayNames = appNames.map(appName => getAppInfo(appName).displayName);
  switch (appNames.length) {
    case 0:
      return unescapedText('toolCallStatus.default.working');
    case 1:
      return unescapedText('toolCallStatus.dashworks_search.oneApp', {
        app: appDisplayNames[0]
      });
    case 2:
      return unescapedText('toolCallStatus.dashworks_search.twoApps', {
        app1: appDisplayNames[0],
        app2: appDisplayNames[1]
      });
    case 3:
      return unescapedText('toolCallStatus.dashworks_search.threeApps', {
        app1: appDisplayNames[0],
        app2: appDisplayNames[1],
        app3: appDisplayNames[2]
      });
    default:
      return unescapedText('toolCallStatus.dashworks_search.manyApps', {
        app1: appDisplayNames[0],
        app2: appDisplayNames[1],
        count: appNames.length - 2
      });
  }
};